angular.module('tct.questionnaireService', ['tct.configService'])
  .factory('questionnaireService', questionnaireService);

questionnaireService.$inject = ['configService', '$http'];

function questionnaireService(config, $http) {
  const basePath = `${config.APP_PROTOCOL}://${config.APP_API}:${config.APP_API_PORT}/api/questionnaires`;
  const factory = {
    getQuestionnaire,
    updateQuestionnaire,
    sendQuestionnaire,
    rejectQuestionnaire,
    approveQuestionnaire,
    getReviewingQuestionnaires,
    setQuestionnaireToDraft,
  };

  return factory;

  function getQuestionnaire(questionnaireId) {
    const url = `${basePath}/${questionnaireId}`;
    return $http.get(url);
  }

  function updateQuestionnaire(questionnaireId, content, score, notes) {
    const url = `${basePath}/${questionnaireId}`;
    return $http.put(url, { content, score, notes });
  }

  function sendQuestionnaire(questionnaireId, content) {
    const url = `${basePath}/${questionnaireId}/review`;
    return $http.put(url, { content });
  }

  function rejectQuestionnaire(questionnaireId) {
    const url = `${basePath}/${questionnaireId}/status`;
    return $http.put(url, { status: 'rejected' });
  }

  function approveQuestionnaire(questionnaireId, content, manualScores) {
    const url = `${basePath}/${questionnaireId}/approve`;
    return $http.put(url, { content, manual_scores: manualScores });
  }

  function getReviewingQuestionnaires(params) {
    const url = `${basePath}/reviewing`;
    return $http.get(url, { params });
  }

  function setQuestionnaireToDraft(questionnaireId, message) {
    const url = `${basePath}/${questionnaireId}/draft`;
    return $http.put(url, { status: 'draft', message });
  }
}
